// extracted by mini-css-extract-plugin
export var title = "Video-module--title--624ea";
export var video = "Video-module--video--bc813";
export var videoContainer = "Video-module--videoContainer--0d6be";
export var wrapper = "Video-module--wrapper--1851e";